// 地图播放器 气泡 图片的操作方法  和app-map 分离 便于查询和使用
const mixin = {
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme
    }
  },
  data() {
    return {
      geteList: []
    }
  },
  methods: {
    //2.公用地图
    // 摄像机打点
    initPage(type = true) {
      // this.addMapGate();
      this.addMapCamera(type)
      // this.showPlayer ? this.$refs.videoPlayer.handleClose() : "";
    },
    addMapCamera(type) {
      let cameraLayerId = 'CAMERA'
      this.cameraList = []
      this.$fetch(this.$api.common.getDeviceListByPage, {
        // 摄像机类型为18
        deviceType: 18,
        page: 1,
        pageSize: 20000
      }).then((res) => {
        if (res.success) {
          let arr = res.returnObj.list
          this.cameraList = []
          arr.forEach((item) => {
            if (item.isIndoor != 0) {
              // 室内摄像机不在地图上渲染
              return
            }
            item.tipsTitle = '摄像机详情'
            let azimuth = item.azimuth || 5
            let obj = {
              id: item.deviceId,
              coord: [Number(item.longitude), Number(item.latitude)],
              anchor: [10, 12],
              azimuth: azimuth,
              scale: 1,
              src: `images/theme/newDark/map/${item.statusName == '在线'
                ? 'camera_' + azimuth + '.png'
                : 'camera_gray' + azimuth + '.png'
                }`,
              sleSrc: `images/theme/newDark/map/${item.statusName == '在线'
                ? 'camera_' + azimuth + '.png'
                : 'camera_gray' + azimuth + '.png'
                }`,
              attr: item,
              showTips: true,
              upDevice: true,
              tipsMap: {
                deviceName: '摄像机名称',
                areaName: '所属区域',
                statusName: '状态',
                factoryName: '厂家',
                createrTime: '创建时间'
              }
            }
            this.cameraList.push(obj)
          })
          this.addMarket(
            this.cameraList,
            cameraLayerId,
            this.handleCameraMapClick
          )

          if (!type) {
            this.setLayerVisibleById(cameraLayerId, type)
          }
        } else {
          this.$message.error(res.msgContent || '查询摄像机列表失败')
        }
      })
    },
    // 公共摄像机弹窗
    handleCameraMapClick(e) {
      console.log(e)
      let deviceType = e.marker.attr.deviceType
      let checkType = e.marker.attr.checkType
      const tipID = 'device_popup'
      this.addPopupMap({
        offset: [10, 12],
        position: e.marker.coord,
        content: '<div id="device_popup"></div>',
        contentId: tipID,
        layerId: tipID
      })
      let deviceTip = new this.vueComponents.deviceDetailTip().$mount(
        '#' + tipID
      )
      deviceTip.data = e.marker.attr
      deviceTip.$on('tipClose', () => {
        this.removePopup(tipID)
      })
    },
    //道闸打点
    addMapGate() {
      let geteListId = 'GATEMAP'
      this.$fetch(this.$api.common.getDeviceListByPage, {
        // 摄像机类型为18,道闸为25
        deviceType: 25,
        page: 1,
        pageSize: 20000
      }).then((res) => {
        if (res.success) {
          ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
            // 设备坐标大于0且存在时为了避免出现页面错乱 如OD
            if (item.latitude && item.longitude) {
              this.geteList.push({
                id: item.deviceId,
                coord: [Number(item.longitude), Number(item.latitude)],
                anchor: [20, 20],
                longitude: item.longitude,
                latitude: item.latitude,
                scale: 1,
                src: `images/theme/newDark/map/resource/${item.statusName == '在线' ? 'gate.png' : 'gate_gray.png'
                  }`,
                attr: item,
                tipsTitle: '道闸详情',
                showTips: true,
                tipsMap: {
                  deviceName: '设备名称',
                  areaName: '所属区域',
                  deviceTypeName: '类型'
                }
              })
            }
          })
          this.addMarket(this.geteList, geteListId)
        } else {
          this.$message.error(res.msgContent || '查询道闸列表失败')
        }
      })
    },
    //广播打点
    getBroadcastList() {
      let broadcastLayerId = 'BROAD_CAST_LAYER'
      let broadcastList = []
      this.$fetch(this.$api.common.getDeviceListByPage, {
        // 广播设备类型为26
        deviceType: 26,
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.success) {
          ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
            item.id = item.deviceId
            item.name = item.deviceName
            broadcastList.push({
              id: item.deviceId,
              coord: [Number(item.longitude), Number(item.latitude)],
              anchor: [10, 12],
              scale: 1,
              src: `images/theme/${this.currentTheme}/map/broadcast_orange.png`,
              attr: item,
              tipsTitle: '广播设备详情',
              // upDevice: true,
              openShout: true,
              openMusic: true,
              showTips: true,
              tipsMap: {
                deviceName: '设备名称'
              }
            })
          })
          this.clearLayer(broadcastLayerId)
          this.addMarket(broadcastList, broadcastLayerId)
        } else {
          this.$message.error(res.msgContent || '查询广播设备列表失败')
        }
      })
    },
    // 修改摄像机位置
    upCoordDevice(type = 'live', olddata = {}) {
      let action = 0
      // 修改坐标
      this.getLocation((data) => {
        action += 1
        const position = [data[0].toFixed(6), data[1].toFixed(6)]
        let alarmPosition = [
          {
            id: olddata.deviceId,
            coord: position,
            anchor: [10, 10],
            src: `images/theme/${this.currentTheme}/map/resource/position_red.png`
          }
        ]
        this.removePoint(olddata.deviceId)
        this.addMarket(alarmPosition)
        if (action === 2) {
          setTimeout(() => {
            this.$confirm(
              '确定将该设备定位到【' +
              position[0] +
              '】【' +
              position[1] +
              '】？',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              })
              .catch(() => {
                action = 0
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                })
              })
          }, 500)
        }
      })
    }
  }
}

export default mixin
